let afterDate = () => {
  return {
      restrict: 'A',
      require: 'ngModel',
      link: (scope, element, attrs, ngModelController) => {
        ngModelController.$validators.afterDate = function(modelValue, viewValue) {
          if (ngModelController.$isEmpty(modelValue) === true) {
              return true;
          }

          let value = moment(modelValue).startOf('day');

          if (!attrs.sbAfterDate) {
            return true;
          }

          let startDate = attrs.sbAfterDate.replace(/\"/g, '');

          startDate = moment(startDate).startOf('day');

          return value.isSameOrAfter(startDate);
        }
      }
  };
};

afterDate.$inject = [];

export default afterDate;



// WEBPACK FOOTER //
// ./client/app/common/field-validators/after-date.js